// src/services/bulkUpload.js
import api from './api';

export const uploadTokensCSV = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/bulk-upload/tokens/csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const uploadTokensJSON = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/bulk-upload/tokens/json', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const uploadTokensTXT = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/bulk-upload/tokens/txt', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const uploadProxiesCSV = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/bulk-upload/proxies/csv', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const uploadProxiesJSON = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/bulk-upload/proxies/json', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Helper function to generate CSV template
export const generateCSVTemplate = (type) => {
  let csvContent = '';
  
  if (type === 'tokens') {
    csvContent = 'token,label,is_active,status,bot_type,client_type,proxy_id\n';
    csvContent += 'OTMwNDQ4NzY3MjM5NDc5MzY3.Yd2B-A.-4gALSTytKA0Nv4Xy23nc8cUHVk,dolorahun1983@mail.com,true,healthy,auto,web,\n';
    csvContent += 'MTIzNDU2Nzg5MDEyMzQ1Ni.AbcDE.FgHIJKlmNopQRstUVwXyz0123456789,example@mail.com,true,healthy,custom,mobile,\n';
  } else if (type === 'proxies') {
    csvContent = 'proxy,is_active,status\n';
    csvContent += 'http://user:pass@proxy.example.com:8080,true,active\n';
    csvContent += 'socks5://user:pass@proxy2.example.com:1080,true,active\n';
  }
  
  return csvContent;
};

// Helper function to generate JSON template
export const generateJSONTemplate = (type) => {
  let template = [];
  
  if (type === 'tokens') {
    template = [
      {
        "token": "OTMwNDQ4NzY3MjM5NDc5MzY3.Yd2B-A.-4gALSTytKA0Nv4Xy23nc8cUHVk",
        "label": "dolorahun1983@mail.com",
        "is_active": true,
        "status": "healthy",
        "bot_type": "auto",
        "client_type": "web",
        "proxy_id": null
      },
      {
        "token": "MTIzNDU2Nzg5MDEyMzQ1Ni.AbcDE.FgHIJKlmNopQRstUVwXyz0123456789",
        "label": "example@mail.com",
        "is_active": true,
        "status": "healthy",
        "bot_type": "custom",
        "client_type": "mobile",
        "proxy_id": null
      }
    ];
  } else if (type === 'proxies') {
    template = [
      {
        "proxy": "http://user:pass@proxy.example.com:8080",
        "is_active": true,
        "status": "active"
      },
      {
        "proxy": "socks5://user:pass@proxy2.example.com:1080",
        "is_active": true,
        "status": "active"
      }
    ];
  }
  
  return JSON.stringify(template, null, 2);
};

// Helper function to generate TXT template
export const generateTXTTemplate = (type) => {
  if (type === 'tokens') {
    return `dolorahun1983@mail.com:UM8M26YaLrOm:OTMwNDQ4NzY3MjM5NDc5MzY3.Yd2B-A.-4gALSTytKA0Nv4Xy23nc8cUHVk
stilasrinri1989@mail.com:kDxlbamUEBmJ:OTI2NjMzMzc5MTI0ODk1NzU1.Yc-gmg.2b9Wh5QAjrjj-G0mj9Ciyw0eewQ
example_user@mail.com:password123:MTIzNDU2Nzg5MDEyMzQ1Ni.AbcDE.FgHIJKlmNopQRstUVwXyz0123456789`;
  }
  return '';
};

// Helper function to validate file type
export const validateFileType = (file, allowedTypes) => {
  const extension = file.name.split('.').pop().toLowerCase();
  return allowedTypes.includes(extension);
};

// Helper function to validate file size
export const validateFileSize = (file, maxSizeMB = 10) => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
};